export default function random(max){
    return Math.floor(Math.random() * Math.floor(max))
}